import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "cancel-flow__screen" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("p", { class: "cancel-flow__eyebrow" }, "Goodbye", -1)
const _hoisted_3 = { class: "cancel-flow__main" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("h2", { class: "cancel-flow__heading" }, "We're sorry to see you go.", -1)
const _hoisted_5 = { class: "cancel-flow__body" }
const _hoisted_6 = { class: "cancel-flow__buttons" }
const _hoisted_7 = ["disabled"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _hoisted_4,
      _createElementVNode("p", _hoisted_5, [
        _createTextVNode(" Your subscription will remain active until "),
        _createElementVNode("strong", null, _toDisplayString(_ctx.periodEndLabel), 1),
        _createTextVNode(". If you change your mind, you can always reactivate your account. ")
      ])
    ]),
    _createElementVNode("div", _hoisted_6, [
      _createElementVNode("button", {
        type: "button",
        class: "cancel-flow__btn cancel-flow__btn--primary",
        disabled: _ctx.finalizing,
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('done')))
      }, "Got it, return to my account", 8, _hoisted_7)
    ])
  ]))
}